"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var _createClass = function () {
  function e(e, r) {
    for (var t = 0; t < r.length; t++) {
      var o = r[t];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
    }
  }

  return function (r, t, o) {
    return t && e(r.prototype, t), o && e(r, o), r;
  };
}(),
    _propTypes = require("prop-types"),
    _propTypes2 = _interopRequireDefault(_propTypes),
    _reactLeaflet = require("react-leaflet"),
    _leaflet = require("leaflet"),
    _leaflet2 = _interopRequireDefault(_leaflet),
    _deepEqual = require("deep-equal"),
    _deepEqual2 = _interopRequireDefault(_deepEqual);

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}

function _classCallCheck(e, r) {
  if (!(e instanceof r)) throw new TypeError("Cannot call a class as a function");
}

function _possibleConstructorReturn(e, r) {
  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return !r || "object" != typeof r && "function" != typeof r ? e : r;
}

function _inherits(e, r) {
  if ("function" != typeof r && null !== r) throw new TypeError("Super expression must either be null or a function, not " + typeof r);
  e.prototype = Object.create(r && r.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(e, r) : e.__proto__ = r);
}

function havingDeprecatedProps(e) {
  return -1 !== e.findIndex(function (e) {
    return e.lat || e.lng;
  });
}

function isArraysEqual(e, r) {
  return e.length === r.length && (0, _deepEqual2.default)(e, r);
}

function removeMarkersWithSameCoordinates(e) {
  var r = [e[0]];
  return e.forEach(function (e) {
    JSON.stringify(r).includes(JSON.stringify(e)) || r.push(e);
  }), r;
}

require("leaflet.markercluster");

var MarkerClusterGroup = function (e) {
  function r() {
    return _classCallCheck(this, r), _possibleConstructorReturn(this, (r.__proto__ || Object.getPrototypeOf(r)).apply(this, arguments));
  }

  return _inherits(r, _reactLeaflet.LayerGroup), _createClass(r, [{
    key: "componentWillMount",
    value: function value() {
      var e = this.props,
          r = e.markers,
          t = e.options;
      t && console.warn('[react-leaflet-markercluster] Warning: "options" property is deprecated and will be removed in v1.2.0. Please see: https://goo.gl/pq3oM7'), this.leafletElement = _leaflet2.default.markerClusterGroup(t || this.props), this.initMapClasses(), r.length && (this.addLayersWithMarkersFromProps(r), havingDeprecatedProps(r) && console.warn('[react-leaflet-markercluster] Warning: marker "lat: xx", "lng: xx" properties are deprecated and will be removed in v1.2.0. Please use "position: [lat, lng]" instead https://goo.gl/s7a6Cj')), this.initEventListeners(this.leafletElement);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function value(e) {
      isArraysEqual(this.props.markers, e.markers) || (this.leafletElement.clearLayers(), e.markers.length && this.addLayersWithMarkersFromProps(e.markers));
    }
  }, {
    key: "initMapClasses",
    value: function value() {
      this.props.wrapperOptions && console.warn('[react-leaflet-markercluster] Warning: "wrapperOptions" property is deprecated and has been removed in v1.1.8. Please see: https://goo.gl/pq3oM7');
    }
  }, {
    key: "addLayersWithMarkersFromProps",
    value: function value(e) {
      var r = this.props,
          t = r.markerOptions,
          o = r.wrapperOptions,
          n = t ? Object.assign({}, t) : {},
          a = [];
      (o && o.removeDuplicates ? removeMarkersWithSameCoordinates(e) : e).forEach(function (e) {
        var r = e.options ? Object.assign({}, e.options) : null,
            t = _leaflet2.default.marker(e.position || [e.lat, e.lng], r || n);

        e.popup && t.bindPopup(e.popup), e.tooltip && t.bindTooltip(e.tooltip), a.push(t);
      }), this.leafletElement.addLayers(a);
    }
  }, {
    key: "initEventListeners",
    value: function value(e) {
      var r = this;
      this.props.onMarkerClick && e.on("click", function (e) {
        r.props.onMarkerClick(e.layer);
      }), this.props.onClusterClick && e.on("clusterclick", function (e) {
        r.props.onClusterClick(e.layer);
      }), this.props.onPopupClose && e.on("popupclose", function (e) {
        r.props.onPopupClose(e.popup);
      });
    }
  }, {
    key: "getLeafletElement",
    value: function value() {
      return this.leafletElement;
    }
  }, {
    key: "getChildContext",
    value: function value() {
      return {
        layerContainer: this.leafletElement
      };
    }
  }, {
    key: "createLeafletElement",
    value: function value(e) {
      return new _leaflet2.default.markerClusterGroup(e.options || e);
    }
  }]), r;
}();

exports.default = MarkerClusterGroup, MarkerClusterGroup.propTypes = {
  markers: _propTypes2.default.arrayOf(_propTypes2.default.object),
  children: _propTypes2.default.node,
  options: _propTypes2.default.object,
  markerOptions: _propTypes2.default.object,
  wrapperOptions: _propTypes2.default.object,
  onMarkerClick: _propTypes2.default.func,
  onClusterClick: _propTypes2.default.func,
  onPopupClose: _propTypes2.default.func
}, MarkerClusterGroup.defaultProps = {
  markers: []
};